import React, { useCallback, useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { Column } from 'primereact/column';

import ButtonSp from '../../components/ButtonSp';
import DataTableSp from '../../components/DataTableSp';

import AtualizacaoEventoService from '../../services/AtualizacaoEventoService';
import { errorHandle } from '../../util/functions';

// Telemetria da frota para esta versão: staged | aplicando | concluida | falha.
function AtualizacaoCrudEvento(props) {
  AtualizacaoCrudEvento.propTypes = {
    versao: PropTypes.string.isRequired,
  };

  const { versao } = props;

  const [eventos, setEventos] = useState([]);

  const handleBuscar = useCallback(async () => {
    if (!versao) {
      return;
    }
    try {
      const result = await AtualizacaoEventoService.findAll({ versao, limit: 50, page: 0 });
      setEventos(result.items);
    } catch (err) {
      errorHandle(err);
    }
  }, [versao]);

  useEffect(() => {
    handleBuscar();
  }, [handleBuscar]);

  return (
    <>
      <div className="p-col-12" style={{ marginTop: 10 }}>
        <b>Eventos dos clientes (telemetria)</b>
        <ButtonSp
          className="p-button-secondary"
          icon="pi pi-refresh"
          title="Atualizar"
          style={{ marginLeft: 10 }}
          onClick={handleBuscar}
        />
      </div>

      <div className="p-col-12 p-fluid datatable-doc-demo">
        <DataTableSp value={eventos} responsive>
          <Column
            field="numeroContrato"
            className="grid-col-curr"
            style={{ width: 100 }}
            header="Contrato"
          />
          <Column
            field="evento"
            className="grid-col"
            style={{ width: 110 }}
            header="Evento"
          />
          <Column field="nomeMaquina" className="grid-col" header="Máquina" />
          <Column field="nomeUsuario" className="grid-col" header="Usuário" />
          <Column
            field="cpfCnpj"
            className="grid-col"
            style={{ width: 140 }}
            header="CNPJ declarado"
          />
          <Column field="ip" className="grid-col" style={{ width: 110 }} header="IP" />
          <Column field="detalhe" className="grid-col" header="Detalhe" />
          <Column
            field="dataEvento"
            className="grid-col"
            style={{ width: 160 }}
            header="Data"
            body={r => (r.dataEvento ? new Date(r.dataEvento).toLocaleString('pt-BR') : '')}
          />
        </DataTableSp>
      </div>
    </>
  );
}

export default AtualizacaoCrudEvento;
